import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Button, Input, Icon, Popconfirm, Select, Checkbox, Alert, Table } from 'antd'
import moment from 'moment'
import { couponStatus } from '@texts/coupons'

import FilterCoupons from './FilterCoupons'
import UpdateCoupons from './UpdateCoupons'

@inject((store: any) => {
    const { popupStore, couponTypesStore, couponsStore, servicesStore } = store
    return { popupStore, couponTypesStore, couponsStore, servicesStore }
})
@observer
export default class CouponsListPopup extends Component<any, any> {
    state: any = {
        errors: {}
    }

    closePopup = () => {
        const {
            popupStore: { togglePopup },
            couponsStore: { resetEditValues }
        } = this.props
        this.setState({ errors: {} })
        resetEditValues()
        togglePopup(false)
    }

    handlePageChange = async page => {
        const {
            couponsStore: { addFilter, getList }
        } = this.props
        await addFilter('page', page)
        await getList()
    }
    render() {
        const {
            popupStore: { popupType },
            couponsStore: {
                list,
                loading,
                editSelected,
                filters,
                selectAll,
                selected,
                pagination: { page: current, perPage: pageSize, total }
            },
            couponTypesStore: { list: couponTypesList }
        } = this.props
        const couponType = couponTypesList.filter(item => item.id === filters.coupon_type_id)[0]

        const footerButtons = (
            <div style={{ display: 'inline-block', width: '100%' }}>
                <Button onClick={this.closePopup}>ביטול</Button>
            </div>
        )
        const editTitle = (
            <>
                עריכה <br />
                <a style={{ textDecoration: 'underline', color: '#e77910' }} onClick={e => selectAll()}>
                    {list.length > selected.length ? 'בחר הכל' : 'נקה הכל'}
                </a>
            </>
        )
        const columns = [
            {
                title: editTitle,
                key: 'edit_id',
                with: 50,
                render: (_, record) => (
                    <Checkbox checked={selected.includes(record.id)} onChange={e => editSelected(record.id)} />
                )
            },
            {
                title: 'מזהה קופון',
                key: 'id',
                render: (_, record) => <span>{record.id}</span>
            },
            {
                title: 'קוד קופון',
                key: 'code',
                render: (_, record) => <span>{record.code}</span>
            },
            {
                title: 'תוקף קופון',
                key: 'expiration_date',
                render: (_, record) => (
                    <span>
                        {record.expiration_date ? moment(record.expiration_date).format('DD/MM/YYYY') : 'ללא הגבלה'}
                    </span>
                )
            },
            {
                title: 'טעינה',
                key: 'load',
                render: (_, record) => <span>{record.load === null ? 'ללא הגבלה' : record.load}</span>
            },
            {
                title: 'מפיץ',
                key: 'reseller_id',
                render: (_, record) => <span>{record.reseller_id}</span>
            },
            {
                title: 'מצב',
                key: 'status',
                render: (_, record) => <span>{couponStatus[record.status]}</span>
            }
        ]
        return (
            <Modal
                title={`קופונים מונפקים עבור ${couponType ? couponType.name : ''}`}
                visible={popupType === 'couponsList'}
                cancelText="ביטול"
                onCancel={this.closePopup}
                footer={footerButtons}
                width={800}
            >
                <UpdateCoupons />
                <FilterCoupons />
                <Table
                    className="center-table"
                    style={{ width: '100%' }}
                    rowKey="id"
                    loading={loading}
                    columns={columns}
                    dataSource={list}
                    pagination={{
                        total,
                        pageSize,
                        current
                    }}
                    onChange={e => this.handlePageChange(e.current)}
                />
            </Modal>
        )
    }
}
